module.exports = __webpack_public_path__ + "img/niño71.e598956b.jpg";